import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || undefined
  },
  getters: {
   userRole(state) {
     return state.userInfo.role || ''
   }
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data
    },
    reset(state) {
      state.userInfo = undefined;
      setTimeout(() => {
        localStorage.clear();
        window.location.reload(true)
      }, 300);
    }
  },
  actions: {},
  modules: {}
})